import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { alert_error, alert_success } from '../../../AppContext';
const YourComponent = () => {
  const ok2 = Cookies.get('apikey');
  const [listcauhinh, setListcauhinh] = useState(null);
  const [nickdangdung, setNickdangdung] = useState(null);
  const [chedokiemxu, setChedokiemxu] = useState(1);
  const [nutxuly, setNutxuly] = useState(null);
  const [idfacebook, setIdfacebook] = useState(null);
  const [usernameIg, setUsernameIg] = useState('');
  const [randomNumber] = useState(Math.floor(Math.random() * 100) + 1);
  const navigate = useNavigate();
  const location = useLocation(); // hook để lấy URL hiện tại

  const params = new URLSearchParams(location.search);
  const social = params.get('mode'); // lấy giá trị 'threads'

  function switch_router(link) {
    navigate(link);
  };
  useEffect(() => {
    if (!ok2) {
      alert('Vui lòng đăng nhập');
    } else {
      checktk();
    }
  }, [ok2]);

  const checktk = () => {
    axios.post('https://hust.media/insta/profile.php', {
      key: ok2,
      chedo: 'listcauhinh',
      social: social
    })
      .then(response => {
        console.log(response.data);
        asdasdkas(response.data);
      })
      .catch(error => console.log(error));
  };

  const asdasdkas = (info) => {
    if (info.status == 3) {
      alert_success('Vui lòng thêm tài khoản chéo Facebook');
      switch_router('/reactapp/insta/themcauhinh');
    } else if (info.status == 0) {
      alert_error(info.message);
    } else if (info.status == 1) {
      alert_success(info.message);
      setListcauhinh(info.listcauhinh);
      setNickdangdung(info.nickdangdung);
      if (info.chedokiemxu) {
        setChedokiemxu(info.chedokiemxu);
      }
    }
  };

  const xacnhan = () => {
    setNutxuly(1);
    setUsernameIg(idfacebook.tenfb);
    setIdfacebook(idfacebook.idfacebook);
    console.log(idfacebook);
    console.log(usernameIg);
    axios.post('https://hust.media/insta/profile.php', {
      key: ok2,
      idfacebook: idfacebook.idfacebook,
      chedo: 'choncauhinh',
      chedokiemxu: chedokiemxu,
      username_ig: usernameIg,
      social: social
    })
      .then(response => {
        console.log(response.data);
        dssdsdvsdvsdv(response.data);
        setNutxuly(0);
      })
      .catch(error => console.log(error));
  };

  const dssdsdvsdvsdv = (info) => {
    if (info.status == 0) {
      alert_error(info.message);
    } else if (info.status == 3) {
      alert_success(info.message);
      switch_router('/reactapp/insta/themcauhinh');
    } else if (info.status == 1) {
      alert_success(info.message);
      switch_router('/reactapp/insta/home');
    } else if (info.status == 4) {
      alert_error(info.message);
    }
    setNutxuly(0);
  };

  return (
    <div className="row fixrow">
      <div className="max-h-16">
        <div className="cards">
          {/* <Adsense 
            data-ad-client="ca-pub-4574266110812955" 
            data-ad-slot="1627514116"
            data-full-width-responsive="no" 
            data-ad-format="horizontal">
          </Adsense> */}
        </div>
      </div>
      <div className="text-center">
        <Link to={`/reactapp/insta/themcauhinh?mode=${social}`}>
          <button type="button" className="mx-2 btn-sm btn-primary">
            THÊM NICK {social} ĐỂ CHẠY
          </button>
        </Link>
        <Link to="/reactapp/insta/home">
          <button type="button" className="mx-2 btn-sm btn-primary">
            Chéo Home
          </button>
        </Link>
      </div>

      <div className="max-w-2xl py-4 mx-auto rounded-lg shadow-xl">
        <div className="panel px-10 panel-primary">
          <div className="panel-heading">
            <h4 className="text-white">DANH SÁCH NICK {social}</h4>
          </div>
          <div className="panel-body">
            {listcauhinh === null ? (
              <div className="container-fluid">
                <div className="row" style={{ backgroundColor: '#FFB6C1' }}>
                  <p className="text-center" style={{ color: '#fff' }}>
                    <div className="text-center spinner-border" role="status"></div>
                    <br />
                    Đang tải danh sách
                  </p>
                </div>
              </div>
            ) : (
              <div className="container-fluid">
                {nickdangdung === null ? (
                  <div className="container-fluid">
                    <p className="text-center" style={{ color: '#fff' }}>
                      <br />
                      <p className="text-sm"> Chọn một tài khoản {social} bên dưới để làm Jop</p>
                    </p>
                  </div>
                ) : (
                  <div id="nickdangdung">
                    {nickdangdung !== null && (
                      <>
                        <label className="block font-bold">Nick đang dùng:</label>
                        <a href={nickdangdung.lienketfb} target="_blank" rel="noopener noreferrer" className="flex items-center">
                          <img src={`data:image/jpeg;base64,${nickdangdung.ava}`} className="w-10 h-10 rounded-full mr-2" alt="Avatar" />
                          <span>{nickdangdung.tenfb}</span>
                        </a>
                      </>
                    )}
                  </div>
                )}
                <ul id="dsnick" className="list-group mt-3 max-h-80 overflow-y-scroll">
                  {listcauhinh.map(user => (
                    <li key={user.id} className="list-group-item">
                      <label className="radio-inline flex items-center">
                        <input
                          type="radio"
                          name="chk"
                          value={user}
                          className="form-radio form-radio-lg h-6 w-6 text-pink-500"
                          checked={idfacebook === user}
                          onChange={() => setIdfacebook(user)}
                        />
                        <a href={user.lienketfb} target="_blank" rel="noopener noreferrer" className="flex items-center">
                          <img src={`data:image/jpeg;base64,${user.ava}`} className="w-10 h-10 rounded-full ml-2 mr-2" alt="Avatar" />
                          <span>{user.tenfb}</span>
                        </a>
                      </label>
                    </li>
                  ))}
                </ul>
                <br />
                <div className="col" onClick={xacnhan}>
                  <div className="fixrow row text-center">
                    <div className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-1 w-auto dark:bg-slate-800 dark:text-white">
                      <div className="m-auto p-2">
                        <button className="flex items-center justify-start flex-1 space-x-4">
                          {nutxuly === '1' ? (
                            <div className="spinner-border" role="status"></div>
                          ) : (
                            <div>
                              <span className="font-medium px-2 text-sm">Đặt làm nick chạy</span>
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <br /><br /><br /><br />
    </div>
  );
};

export default YourComponent;
